import type { ButtonProps } from '@/design-system/components/Button';

import { DatasetSchema, RunSchema } from '../../types/schema';
import { NewDatasetCrudPane } from './NewDatasetCrudPane';

export interface BaseProps {
  dataType?: DatasetSchema['data_type'][];
  dataset?: DatasetSchema;
  asLink?: boolean;
  onSuccess?: (id: string, dataset: DatasetSchema) => void;
  color?: ButtonProps['color'];
  variant?: ButtonProps['variant'];
  disabled?: boolean;
  prefilledData?: Partial<DatasetSchema>;
  // used for adding runs to dataset
  preselectedRuns?: Pick<RunSchema, 'inputs' | 'outputs' | 'extra' | 'id'>[];
  // used for creating a new dataset from a selected run type
  baseDatasetOnRunType?: RunSchema['run_type'];
}

type PaneProps = Omit<BaseProps, 'asLink'> & {
  label: string;
  open: boolean;
  onCancel: () => void;
  isKVEnabled?: boolean;
  isChatEnabled?: boolean;
  isLLMEnabled?: boolean;

  needsConvertPreselectedChatRuns?: boolean;
} & (
    | {
        isManualIO?: false;
        preselectedRunIds?: string[];
      }
    | {
        isManualIO: true;
        preselectedRuns?: Pick<
          RunSchema,
          'inputs' | 'outputs' | 'extra' | 'id'
        >[];
      }
  );

export function DatasetCrudPane(props: PaneProps) {
  return <NewDatasetCrudPane {...props} />;
}
